<template>
  <el-dialog
     width="650px"
    :title="$t('button.i18nImport')"
    :visible.sync="importVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div>
      <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="auto">
        <el-form-item :label="$t('button.downloadTemplate')">
          <DiluButton
            type="export"
            @click="langTemplate"
            :title="$t('button.downloadTemplate')"
          ></DiluButton>
          <span>{{ $t("pages.equipment.text61") }}</span>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text63')">
          <DiluButton
            type="import"
            @click="langImport"
            :title="$t('pages.equipment.text63')"
            :fileList="fileList"
          ></DiluButton>
          <span>{{ $t("pages.equipment.text62") }}</span>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
      <el-button type="primary" @click="submitForm">{{$t("button.determine")}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        protocolId: "",
        excel: "",
      },
      fileList: [],
      rules: {},
    };
  },
  components: {
    DiluButton,
  },
  watch: {
    importVisible(newValue) {
      if (newValue) {
        this.ruleForm.protocolId = this.codeInfo.protocolId;
      }
    },
  },
  computed: {
    ...mapState(["platformData"]),
  },
  props: ["importVisible","codeInfo","codeList"],
  methods: {
    handleClose() {
      this.fileList = [];
      this.$emit("dialogClose");
    },
    submitForm() {
      let that = this;
      that.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!that.ruleForm.excel) {
            return that.$message.error(that.$t("pages.equipment.text63"));
          }
          that.request.langImport(that.ruleForm).then((res) => {
              
             that.$emit("codeList");
              that.handleClose();
          }).catch(() => {
            that.$message.success(that.$t("pages.equipment.text68"));
          });
        }
      });
    },
    //下载模版
    langTemplate() {
      this.request.langTemplate().then();
    },
    //选择Excel上传
    langImport(e) {
      this.ruleForm.excel = e;
    },
  },
};
</script>

<style scoped>
  
</style>